import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import AssetWrapper from 'src/app/atoms/Asset/AssetWrapper';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { SpacingPropKeys } from 'src/app/styles/spacing';
import { IStaticContentfulImages } from 'src/types/contentful';

interface SocialProofBadgesProps {
  gap?: SpacingPropKeys;
}

const SocialProofBadges = ({ gap = 'spacing-3xl' }: SocialProofBadgesProps): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      usersLoveUs: contentfulAsset(contentful_id: { eq: "55APT4ExQmVIOisjFk5Vt2" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 600)
      }
      gridLeader: contentfulAsset(contentful_id: { eq: "388NuqgXIcygVoOZ6b4DA2" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 600)
      }
      momentumLeader: contentfulAsset(contentful_id: { eq: "gTEZ1vr69yPgZ6mgj1TaO" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 600)
      }
    }
  `);

  return (
    <Grid
      gap={gap}
      totalColumnsLg={10}
    >
      <Stack
        columns={4}
        columnsLg={3}
        align='center'
        justify='center'
      >
        <AssetWrapper
          imageProps={{ image: images.momentumLeader.gatsbyImageData, alt: 'Momentum Leader Badge' }}
          maxWidth={142}
        />
      </Stack>
      <Stack
        columns={4}
        align='center'
        justify='center'
      >
        <AssetWrapper
          imageProps={{ image: images.usersLoveUs.gatsbyImageData, alt: 'Users Loves Us Badge' }}
          maxWidth={192}
        />
      </Stack>
      <Stack
        columns={4}
        columnsLg={3}
        align='center'
        justify='center'
      >
        <AssetWrapper
          imageProps={{ image: images.gridLeader.gatsbyImageData, alt: 'Grid Leader Badge' }}
          maxWidth={142}
        />
      </Stack>
    </Grid>
  );
};

export default SocialProofBadges;
